import { AxiosResponse } from "axios";
import API from "../api";
import { Checklist } from "../models/checklist";

import BaseService from "./_base.service";

const endpoint = "checklists";

const ChecklistService = {
  ...BaseService<Checklist>({ endpoint }),
  async getById(id: number, options?: any): Promise<AxiosResponse<Checklist>> {
    return await API.get(`${endpoint}/${id}`, { params: options });
  },
};

export default ChecklistService;
